import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import ProductDetailsOne from "../components/ProductDetailsOne";
import NewArrivalTwo from "../components/NewArrivalTwo";
import ShippingOne from "../components/ShippingOne";
import NewsletterOne from "../components/NewsletterOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import BreadcrumbTwo from "../components/BreadcrumbTwo";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";

const ProductDetailsPageOne = () => {
  const { id } = useParams();

  const CK = process.env.REACT_APP_WC_CK;
  const CS = process.env.REACT_APP_WC_CS;

  const [product, setProduct] = useState(null);
  const [categoryProducts, setCategoryProducts] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/product/${id}/`)
      .then((res) => res.json())
      .then((res) => {
        if (res.status) {
          setProduct(res.data);
        } else {
          console.error("Product fetch failed", res.error);
        }
      })
      .catch((err) => console.error("Product fetch error:", err));
  }, [id]);


  // Fetch category products
  useEffect(() => {
    if (!product) return;

    const categoryId = product.categories[0]?.id;
    if (!categoryId) return;

    fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/category-products/?category=${categoryId}`
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.status) {
          setCategoryProducts(res.data);
        } else {
          console.error("Category products fetch failed", res.error);
        }
      })
      .catch((err) =>
        console.error("Category products fetch error:", err)
      );
  }, [product]);

  return (
    <>
      <Preloader />
      <ColorInit color={false} />
      <ScrollToTop smooth color="#299E60" />
      <HeaderOne />
      <BreadcrumbTwo title={"Product Details"} />

      {/*  PASS PRODUCT HERE */}
      <ProductDetailsOne product={product} />

      <NewArrivalTwo products={categoryProducts} />
      <ShippingOne />
      <NewsletterOne />
      <FooterOne />
      <BottomFooter />
    </>
  );
};

export default ProductDetailsPageOne;
